"use client"

import clsx from "clsx"
import { MouseEventHandler } from "react"
import { NpIcon } from "../NpIcon"

export type NpProductThumbnailProps = {
  side: "left" | "right"
  disabled?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export const NpCarouselArrow = ({ side, disabled, onClick }: NpProductThumbnailProps) => (
  <button
    type="button"
    disabled={disabled}
    title={side === "left" ? "Zurück" : "Weiter"}
    onClick={onClick}
    className={clsx(
      "border-np-green relative flex size-10 shrink-0 items-center justify-center rounded-full border bg-white/50 backdrop-blur-xs transition-colors hover:transition-none",
      {
        hidden: disabled,
        "hover:bg-np-green10/75 active:bg-np-green10/50": !disabled,
      },
    )}
  >
    <NpIcon name="arrow_backward_lg" className={clsx("text-np-green size-6", side === "right" && "rotate-180")} />
  </button>
)
